module.exports = __webpack_public_path__ + "img/222.d636cbe9.gif";